import { GetCrossSellRenderer, ItemCard, ItemCategoryCardShape, WidgetTypes } from "./types";

const setRenderCrossSellOnItemCards = (
    itemCards: ItemCard[] | undefined,
    getCrossSellRenderer: GetCrossSellRenderer
): ItemCard[] | undefined => {
    return itemCards?.map((item) => {
        if (item?.card?.["@type"] === WidgetTypes.DISH_WIDGET) {
            const itemId = String(item.card.info?.id ?? "");
            return {
                ...item,
                card: { ...item.card, renderCrossSellItems: getCrossSellRenderer?.(itemId) },
            };
        }
        return item;
    });
};

export const injectRenderCrossSellIntoCard = (
    cardObj: ItemCategoryCardShape,
    getCrossSellRenderer: GetCrossSellRenderer
) => {
    if (Array.isArray(cardObj.itemCards)) {
        cardObj.itemCards = setRenderCrossSellOnItemCards(cardObj.itemCards, getCrossSellRenderer);
    }
    if (Array.isArray(cardObj.categories)) {
        cardObj.categories.forEach((cat) => {
            if (Array.isArray(cat.itemCards)) {
                cat.itemCards = setRenderCrossSellOnItemCards(cat.itemCards, getCrossSellRenderer);
            }
        });
    }
};
